import {
  HomePage,
  AboutUsPage,
  CareersPage,
  OurLicensedAgentsPage,
  TransitionYourAgencyPage,
  ContactUsPage,
  InsurancePlansPage,
  ResourcesPage,
} from './index'
import { RouteFactory } from './../../shared/router/Route.factory'

export default [
  RouteFactory.create(HomePage, '/', [], {
    name: 'Health Insurance Franchise | USA Benefits Group',
  }),
  RouteFactory.create(AboutUsPage, '/about-us', [], {
    name: 'About Us | Health Insurance Franchise | USA Benefits Group',
  }),
  RouteFactory.create(CareersPage, '/careers', [], {
    name: 'Careers | Health Insurance Franchise | USA Benefits Group',
  }),
  RouteFactory.create(OurLicensedAgentsPage, '/our-licensed-agents', [], {
    name: 'Our Licensed Agents | Health Insurance Franchise | USA Benefits Group',
  }),
  RouteFactory.create(TransitionYourAgencyPage, '/transition-your-agency', [], {
    name: 'Transition Your Agency | Health Insurance Franchise | USA Benefits Group',
  }),
  RouteFactory.create(ContactUsPage, '/contact', [], {
    name: 'Contact Us | Health Insurance Franchise | USA Benefits Group',
  }),
  RouteFactory.create(InsurancePlansPage, '/health-insurance', [], {
    name: 'Health Insurance | Health Insurance Franchise | USA Benefits Group',
  }),
  RouteFactory.create(InsurancePlansPage, '/medicare-insurance', [], {
    name: 'Medicare Insurance | Health Insurance Franchise | USA Benefits Group',
  }),
  RouteFactory.create(InsurancePlansPage, '/life-insurance', [], {
    name: 'Life Insurance | Health Insurance Franchise | USA Benefits Group',
  }),
  RouteFactory.create(InsurancePlansPage, '/small-business-insurance', [], {
    name: 'Small Business Insurance | Health Insurance Franchise | USA Benefits Group',
  }),
  RouteFactory.create(ResourcesPage, '/resources', [], {
    name: 'Resources | USA Benefits Group',
  }),
]
